module.exports = __webpack_public_path__ + "b3d0af00d2a6e04411ed53126da43465.pdf";